'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var THEME_CHANNEL = exports.THEME_CHANNEL = '_FELA_THEME_';